import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Priority } from "@app/models/rest/priority";

@Injectable({
  providedIn: "root"
})
export class PriorityRestService extends HateoasResourceOperation<Priority> {
  constructor() {
    super(Priority);
  }
}
